import { CompanyAlias } from 'api';
import { cashFlowLedgerUrl, companySummaryUrl } from 'common/config/urls';
import { ENTITY_QUERY_PARAM } from 'common/constants/pageFilters';

export type CompanyAliasSummary = Pick<CompanyAlias, 'id' | 'kind' | 'name'>;

// How an alias reads in search, e.g. "Campaign Monitor - now Marigold".
export const getCompanyAliasLabel = (alias: CompanyAliasSummary, companyName: string) =>
  `${alias.name} - ${alias.kind === CompanyAlias.kind.ACQUIRED ? 'part of' : 'now'} ${companyName}`;

// A former name opens the company itself; an acquired company only exists as a Cash Flow Ledger entity.
export const getCompanyAliasPath = (alias: CompanyAliasSummary, firmSlug: string, companySlug: string) =>
  alias.kind === CompanyAlias.kind.ACQUIRED
    ? `${cashFlowLedgerUrl(firmSlug, companySlug)}?${ENTITY_QUERY_PARAM}=alias-${alias.id}`
    : companySummaryUrl(firmSlug, companySlug);
